import BanzaiSeriesService from '@/services/banzai-series.service'
import {AxiosInstance} from 'axios'
import _Vue from 'vue'

export default {
  install (
    Vue: typeof _Vue,
    { http }: { http: AxiosInstance }) {
    Vue.prototype.$banzaiSeries = new BanzaiSeriesService(http)
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $banzaiSeries: BanzaiSeriesService;
  }
}
